import { FolderIcon } from '../../../../../assets/svg/FolderIcon';
import styles from './FolderList.module.scss';

interface IFolderListProps {
  folders: Array<{ id: number; name: string }>;
  onFolderClick: (folderId: number) => void;
}

export const FolderList = ({ folders, onFolderClick }: IFolderListProps) => {
  return (
    <div className={styles.templateList}>
      {folders && folders.length > 0 ? (
        <>
          {folders.map((folder) => {
            return (
              <div 
                key={folder.id} 
                className={styles.contentItem} 
                onClick={() => onFolderClick(folder.id)}
              >
                <FolderIcon />
                <span className={styles.contentItemText}>{folder.name}</span>
              </div>
            )
          })}
        </>
      ) : (
        <div className={styles.emptyMessage}>No folders found</div>
      )}
    </div>
  );
};